// /**
//  * 该文件夹下所有文件来源于inversify
//  * https://github.com/inversify/InversifyJS
//  * The MIT License (MIT)

// Copyright (c) 2015-2017 Remo H. Jansen

// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:

// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.

// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
//  */

// export { ContainerModule } from './container/container_module';
// export { inject } from './annotation/inject';
// export { multiInject } from './annotation/multi_inject';
// export { injectable } from './annotation/injectable';
// export { named } from './annotation/named';
// export { Container } from './container/container';
// // export { postConstruct } from './annotation/post_construct';
// export * from './interfaces/interfaces';

export * from '../inversify';
